<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode" :funcClick="bindClickInterface" :funcKeyUp='bindKeyUpInterface'></ParseForm>
      </template>
      <template>
        <ParseList ref='zonal' :formId="formItems.zonal.formId" :formParams="formItems.zonal.formObj" :opCode="opCode" :Title="formItems.zonal.title"
          :maxLength="formItems.zonal.maxLength" :minLength="formItems.zonal.minLength" >
        </ParseList>
      </template>
      <template>
        <ParseList ref='mccmnc' :formId="formItems.mccmnc.formId" :formParams="formItems.mccmnc.formObj" :opCode="opCode" :Title="formItems.mccmnc.title"
          :maxLength="formItems.mccmnc.maxLength" :minLength="formItems.mccmnc.minLength" >
        </ParseList>
      </template>
      <PdnProfileList ref='pdnProfileList' :getCheckedDatas='getCheckedList' :ne="ne"></PdnProfileList>
    </div>
  </div>
</template>
<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import PdnProfileList from "./PdnProfileList";
import CustomDialog from '../../../../common/CustomDialog';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ParseList from '../../../util/parseFormNew/ParseList';
import ajaxUrl from "../../../data/ajaxUrl";
import {EventBus} from "../../../../../plugins/eventBus";

export default {
  name: "AddProfileForm",
  components: {
    ParseForm,
    PdnProfileList,
    CustomDialog,
    ParseList,
  },
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {

          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.zonal) {
        if (!this.$refs.zonal.validateResult()) {

          return;
        }
        const zonal = this.$refs.zonal.getDatas();
        map.set('zonalCodeObj', zonal.list);
      }
      if (this.$refs.mccmnc) {
        if (!this.$refs.mccmnc.validateResult()) {

          return;
        }
        const mccmnc = this.$refs.mccmnc.getDatas();
        map.set('mccmncObj', mccmnc.list);
      }
      console.log(map);
      return map;
    },
    getJson(ne, callback) {
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.addProfileJson, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, []);

        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        this.formItems.mccmnc.formObj = resultMap.get(this.formItems.mccmnc.modelName);
        this.formItems.zonal.formObj = resultMap.get(this.formItems.zonal.modelName);

        callback(response);
      });
    },
    /**
    * 数组去重函数
    * @param array
    * @returns {Array}
    */
    arrayDistinct: function (array) {
      const res = [];
      const json = {};
      try {
        for (let i = 0; i < array.length; i++) {
          const temp = JSON.stringify(array[i]);
          if (!json[temp]) {
            res.push(array[i]);
            json[temp] = 1;
          }
        }
      } catch (err) {
        console.log(err.message);
      }
      return res;
    },
    saveProfile(ne, callback) {
      const formData = this.getDatas();
      if (formData) {
        const pdnList = formData.get("pdnProfileLst").split(',').filter((item) => { return item !== "" });
        const zonalList = formData.get("zonalCodeObj");
        const mccmncList = formData.get("mccmncObj");
        // 判断mccmnc列表是否有重复数据
        const mccmncListT = this.arrayDistinct(mccmncList);
        if (mccmncListT.length !== mccmncList.length) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t("Profile.repeatMCCMNC")});
          return;
        }
        // 判断漫游区域码是否有重复数据
        const zonalListT = this.arrayDistinct(zonalList);
        if (zonalListT.length !== zonalList.length) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t("Profile.repeatCode")});
          return;
        }
        // const zonalList = ["3333"];
        // const mccmncList = [{ mcc: '343', mnc: '43' }];

        const pdnList2 = [];
        for (let i=0; i<11; i++) {
          pdnList2.push({"profileId": pdnList[i] || ''})
        }
        const zonalList2 = [];
        for (let i=0; i<10; i++) {
          zonalList2.push({"zonalCode": zonalList[i] ? zonalList[i].zonalCode : '0'})
        }
        const mccmncList2 = [];
        for (let i=0; i<20; i++) {
          mccmncList2.push({
            "mcc": mccmncList[i] ? mccmncList[i].mcc : '0',
            "mnc": mccmncList[i] ? mccmncList[i].mnc : '0',
          })
        }
        const params = {
          vo: {
            "neid": ne.neid,
            "grpid": '0',
            "zonalCode": formData.get("zonalCode"),
            "profileId": formData.get("profileId"),
            "profileName": formData.get("profileName"),
            "pdnProfileLst": {
              "count": pdnList.length,
              "list": pdnList2,
            },
            "dftPDNProfileID": formData.get("dftPDNProfileID"),
            "chargingChars": formData.get("chargingChars"),
            "profileMaxUl": formData.get("profileMaxUl"),
            "profileMaxDl": formData.get("profileMaxDl"),
            "subsPeriodicRauTauTimer": formData.get("subsPeriodicRauTauTimer"),
            "mcc0": formData.get("mcc0"),
            "mnc0": formData.get("mnc0"),
            "mccmnc": formData.get("mccmnc"),
            "zonalCodeObj": {
              "count": zonalList.length,
              "list": zonalList2,
            },
            "mccmncObj": {
              "count": mccmncList.length,
              "list": mccmncList2,
            },
            "zonalcode": "",
          },
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          },
          log: {
            module: 'res.subscriber#res.subscriber_lte#res.subscriber_lte_profile',
            execFunName: 'subscriber.epcAddProfile',
            exectype: 1,
            execData: [formData.get("profileId")]
          }
        };
        this.$axios.post(ajaxUrl.requestCommon, params).then((response) => {
          if (callback) {
            callback(response);
          }
        });
      }
    },
    showProfileList() {
      this.$refs.pdnProfileList.qryList(this.ne);
      this.$refs.pdnProfileList.show();
    },
    getCheckedList(list) {
      this.selectedKeys = [...list];
      let value = '';
      let range = '';
      for(let i=0; i<list.length; i++) {
        value += list[i];
        range += list[i];
        if(i != list.length-1) {
          value += ',';
          range += '|';
        }
      }
      const validate = {
        required: [true, this.$t("PDN.required")],
        regex: [`^(${range})$`,this.$t("PDN.partofpdn")],
      };
      if(this.$refs.basic) {
        this.$refs.basic.setData('pdnProfileLst', value);
        this.$refs.basic.validateResult(['pdnProfileLst']);
        this.$refs.basic.setValidate('dftPDNProfileID', validate);
      }
    },
    onclickPdnProfileLst() {
      this.$refs.pdnProfileList.qryList(this.ne);
      this.$refs.pdnProfileList.show();
    },
    bindUtf8CodeLengthRegex(name, maxLength) {
      const $this = this;
      this.funcKeyUpMap.set(name, () => {
        const _rule = {
          regex: [$this.regex.char, $this.$t('MCS.noSpecialChar')]
        };
        $this.$refs.basic.removeValidate(name);
        $this.$refs.basic.setValidate(name, _rule);
        if ($this.$refs.basic.validateResult([name]) === true) {
          if ($this.utf8Length($this.$refs.basic.getDatas().get(name), maxLength) === false) {
            const _utf8Rule = {
              regex: [$this.regex.noMatchRegex, this.$t('Profile.charAt32')]
            };
            $this.$refs.basic.removeValidate(name);
            $this.$refs.basic.setValidate(name, _utf8Rule);
          }
        }
      });
    },
    utf8Length(inputStr, maxLength) {
      let totalLength = 0;
      /* 计算utf-8编码情况下的字符串长度 */
      for (let i = 0; i < inputStr.length; i++) {
        if (inputStr.charCodeAt(i) <= parseInt(0x7F)) {
          totalLength += 1;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x7FF')) {
          totalLength += 2;
        } else if (inputStr.charCodeAt(i) <= parseInt('0xFFFF')) {
          totalLength += 3;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x1FFFFF')) {
          totalLength += 4;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x3FFFFFF')) {
          totalLength += 5;
        } else {
          totalLength += 6;
        }
      }
      return totalLength <= maxLength;
    },
  },
  computed: {
    bindClickInterface() {
      this.funcMap = new Map();
      this.funcMap.set('pdnProfileLst', () => { this.onclickPdnProfileLst(); });
      return this.funcMap;
    },
    bindKeyUpInterface() {
      this.funcKeyUpMap = new Map();
      this.bindUtf8CodeLengthRegex('profileName', 32);
      return this.funcKeyUpMap;
    },
  },
  data() {
    return {
      regex: {
        char: '^[a-zA-Z0-9\u4e00-\u9fa5]+$',
        noMatchRegex: '^@_-@_-@_-@_-@_-@_$'
      },
      ne: null,
      selectedKeys: [],
      funcMap: null,
      funcKeyUpMap:null,
      formItems: {
        basic: {
          formId: "ProfileAddProfileInfo",
          modelName: "basic",
          formObj: null,
        },
        mccmnc: {
          title: this.$t("Profile.mccMncCode"),
          formId: "ProfileAddMccMncInfo",
          modelName: "mccmnc",
          formObj: null,
          maxLength: 20,
          minLength: 1,
        },
        zonal: {
          title: this.$t("Profile.zonalCode"),
          formId: "ProfileAddZonalInfo",
          modelName: "zonal",
          formObj: null,
          maxLength: 10,
        },
      },
      opCode: "add",
      msgId: "17056",
    };
  },
  beforeDestroy() {
  }
};
</script>
